export default __webpack_public_path__ + "static/media/icon-deselect.50d1a640.svg";